<template>
  <section
    id="ss-master"
    class="ui-card ss-card ss-master"
    :class="{ 'is-on': on, 'is-changed': ctl.changed('lice_bez_ugovora'), 'is-flash': ctl.ui.flash === 'master' }"
  >
    <div class="ss-master__r" @click="flip">
      <span class="ss-master__i"><v-icon size="22">mdi-storefront-outline</v-icon></span>
      <div class="ss-sw__t">
        <b>{{ $t("ordering_persons_without_contract") }}</b>
        <span>{{ $t("settings_shell.offer.master_d") }}</span>
      </div>
      <span class="ui-chip ui-chip--pill" :class="on ? 'ui-chip--ok' : ''">{{ $t(on ? "settings_shell.v.on" : "settings_shell.v.off") }}</span>
      <ui-switch tone="accent" :value="Boolean(on)" :label="$t('ordering_persons_without_contract')" @input="flip" />
    </div>
  </section>
</template>

<script>
/** Glavni prekidač gostiju (lica bez ugovora): dok je isključen, ostatak ekrana Gosti je sakriven. */
export default {
  name: "SetGuestMaster",
  inject: { ctl: "settingsCtl" },
  computed: {
    on() {
      return Boolean(this.ctl.val("lice_bez_ugovora"));
    },
  },
  methods: {
    flip() {
      this.ctl.toggle("lice_bez_ugovora");
    },
  },
};
</script>
